import Vue from "vue";
import VueRouter from "vue-router";

// import BoardList from "../views/EnergyBoard/BoardList.vue";
// import BoardDetails from "../views/EnergyBoard/BoardDetails.vue";
// import BoardAdd from "../views/EnergyBoard/BoardAdd.vue";
// import BoardEdit from "../views/EnergyBoard/BoardEdit.vue";

// import AirQualityList from "../views/AirQualityBoard/AirQualityList.vue";
// import AirQualityAdd from "../views/AirQualityBoard/AirQualityAdd.vue";
// import AirQualityEdit from "../views/AirQualityBoard/AirQualityEdit.vue";

// import WaterList from "../views/WaterBoard/WaterList.vue";
// import WaterDetails from "../views/WaterBoard/WaterDetails.vue";
// import WaterAdd from "../views/WaterBoard/WaterAdd.vue";
// import WaterEdit from "../views/WaterBoard/WaterEdit.vue";

// import WaterTankList from "../views/WaterTank/WaterTankList.vue";
// import WaterTankDetails from "../views/WaterTank/WaterTankDetails.vue";
// import WaterTankAdd from "../views/WaterTank/WaterTankAdd.vue";
// import WaterTankEdit from "../views/WaterTank/WaterTankEdit.vue";

// import SinglePhaseList from "../views/SinglePhase/SinglePhaseList.vue";
// import SinglePhaseDetails from "../views/SinglePhase/SinglePhaseDetails.vue";
// import SinglePhaseAdd from "../views/SinglePhase/SinglePhaseAdd.vue";
// import SinglePhaseEdit from "../views/SinglePhase/SinglePhaseEdit.vue";

// import Overview from '../views/Overview/Overview.vue'
// import Location from "../views/Location/Location.vue";
// import Meter from "../views/Meter/Meter.vue";

// import UsageByDbEnergy from "../views/Energy/UsageByDb.vue";
// import UsageByPhaseEnergy from "../views/Energy/UsageByPhase.vue";
// import UsageByLocationEnergy from "../views/Energy/UsageByLocation.vue";

// import AQByLocation from "../views/AirQuality/AQByLocation.vue";

// import Report from "../views/Report/Report.vue";

// import UsageByLocationWaterFlow from "../views/WaterFlow/UsageByLocation.vue";
// import WaterFlow0 from "../views/WaterFlow/WaterFlow0.vue";
// import WaterFlow1 from "../views/WaterFlow/WaterFlow1.vue";
// import WaterFlow2 from "../views/WaterFlow/WaterFlow2.vue";
// import WaterFlow3 from "../views/WaterFlow/WaterFlow3.vue";
// import WaterFlow4 from "../views/WaterFlow/WaterFlow4.vue";
// import WaterFlow5 from "../views/WaterFlow/WaterFlow5.vue";

// import OverviewWaterTank from "../views/WaterLevelTank/Overview.vue";

// import C_1A from "../views/BoardChannelDetails/C_1A.vue";
// import C_1B from "../views/BoardChannelDetails/C_1B.vue";
// import C_1C from "../views/BoardChannelDetails/C_1C.vue";
// import C_1D from "../views/BoardChannelDetails/C_1D.vue";
// import C_1E from "../views/BoardChannelDetails/C_1E.vue";
// import C_1F from "../views/BoardChannelDetails/C_1F.vue";
// import C_1G from "../views/BoardChannelDetails/C_1G.vue";
// import C_1H from "../views/BoardChannelDetails/C_1H.vue";

// import C_2A from "../views/BoardChannelDetails/C_2A.vue";
// import C_2B from "../views/BoardChannelDetails/C_2B.vue";
// import C_2C from "../views/BoardChannelDetails/C_2C.vue";
// import C_2D from "../views/BoardChannelDetails/C_2D.vue";
// import C_2E from "../views/BoardChannelDetails/C_2E.vue";
// import C_2F from "../views/BoardChannelDetails/C_2F.vue";
// import C_2G from "../views/BoardChannelDetails/C_2G.vue";
// import C_2H from "../views/BoardChannelDetails/C_2H.vue";

// import C_3A from "../views/BoardChannelDetails/C_3A.vue";
// import C_3B from "../views/BoardChannelDetails/C_3B.vue";
// import C_3C from "../views/BoardChannelDetails/C_3C.vue";
// import C_3D from "../views/BoardChannelDetails/C_3D.vue";
// import C_3E from "../views/BoardChannelDetails/C_3E.vue";
// import C_3F from "../views/BoardChannelDetails/C_3F.vue";
// import C_3G from "../views/BoardChannelDetails/C_3G.vue";
// import C_3H from "../views/BoardChannelDetails/C_3H.vue";

// import C_4A from "../views/BoardChannelDetails/C_4A.vue";
// import C_4B from "../views/BoardChannelDetails/C_4B.vue";
// import C_4C from "../views/BoardChannelDetails/C_4C.vue";
// import C_4D from "../views/BoardChannelDetails/C_4D.vue";
// import C_4E from "../views/BoardChannelDetails/C_4E.vue";
// import C_4F from "../views/BoardChannelDetails/C_4F.vue";
// import C_4G from "../views/BoardChannelDetails/C_4G.vue";
// import C_4H from "../views/BoardChannelDetails/C_4H.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  board: process.env.BOARD_URL,
  routes: [
    {
      path: "/",
      name: "Overview",
      component: () => import("../views/Overview/Overview.vue"),
    },
    {
      path: "/board",
      name: "Board List",
      component: () => import("../views/EnergyBoard/BoardList.vue"),
    },
    {
      path: "/board/details/:id",
      name: "Board Details",
      component: () => import("../views/EnergyBoard/BoardDetails.vue"),
    },
    {
      path: "/board/add",
      name: "Board Add",
      component: () => import("../views/EnergyBoard/BoardAdd.vue"),
    },
    {
      path: "/board/edit/:id",
      name: "Board Edit",
      component: () => import("../views/EnergyBoard/BoardEdit.vue"),
    },
    {
      path: "/air-quality",
      name: "Air Quality List",
      component: () => import("../views/AirQualityBoard/AirQualityList.vue"),
    },
    {
      path: "/air-quality/add",
      name: "Air Quality Add",
      component: () => import("../views/AirQualityBoard/AirQualityAdd.vue"),
    },
    {
      path: "/air-quality/edit/:id",
      name: "Air Quality Edit",
      component: () => import("../views/AirQualityBoard/AirQualityEdit.vue"),
    },
    {
      path: "/water-board",
      name: "Water List",
      component: () => import("../views/WaterBoard/WaterList.vue"),
    },
    {
      path: "/water-board/details/:id",
      name: "Water Details",
      component: () => import("../views/WaterBoard/WaterDetails.vue"),
    },
    {
      path: "/water-board/add",
      name: "Water Add",
      component: () => import("../views/WaterBoard/WaterAdd.vue"),
    },
    {
      path: "/water-board/edit/:id",
      name: "Water Edit",
      component: () => import("../views/WaterBoard/WaterEdit.vue"),
    },
    {
      path: "/water-tank",
      name: "Water Tank List",
      component: () => import("../views/WaterTank/WaterTankList.vue"),
    },
    {
      path: "/water-tank/details/:id",
      name: "Water Tank Details",
      component: () => import("../views/WaterTank/WaterTankDetails.vue"),
    },
    {
      path: "/water-tank/add",
      name: "Water Tank Add",
      component: () => import("../views/WaterTank/WaterTankAdd.vue"),
    },
    {
      path: "/water-tank/edit/:id",
      name: "Water Tank Edit",
      component: () => import("../views/WaterTank/WaterTankEdit.vue"),
    },
    {
      path: "/single-phase",
      name: "Single Phase List",
      component: () => import("../views/SinglePhase/SinglePhaseList.vue"),
    },
    {
      path: "/single-phase/details/:id",
      name: "Single Phase Details",
      component: () => import("../views/SinglePhase/SinglePhaseDetails.vue"),
    },
    {
      path: "/single-phase/add",
      name: "Single Phase Add",
      component: () => import("../views/SinglePhase/SinglePhaseAdd.vue"),
    },
    {
      path: "/single-phase/edit/:id",
      name: "Single Phase Edit",
      component: () => import("../views/SinglePhase/SinglePhaseEdit.vue"),
    },
    {
      path: "/location",
      name: "Location",
      component: () => import("../views/Location/Location.vue"),
    },
    {
      path: "/meter",
      name: "Meter",
      component: () => import("../views/Meter/Meter.vue"),
    },
    {
      path: "/aq-by-location",
      name: "AQ By Location",
      component: () => import("../views/AirQuality/AQByLocation.vue"),
    },
    {
      path: "/usage-by-db-energy",
      name: "Usage By Db Energy",
      component: () => import("../views/Energy/UsageByDb.vue"),
    },
    {
      path: "/usage-by-location-energy",
      name: "Usage By Location Energy",
      component: () => import("../views/Energy/UsageByLocation.vue"),
    },
    {
      path: "/usage-by-phase-energy",
      name: "Usage By Phase Energy",
      component: () => import("../views/Energy/UsageByPhase.vue"),
    },
    {
      path: "/usage-by-location-water-flow",
      name: "Usage By Location Water Flow",
      component: () => import("../views/WaterFlow/UsageByLocation.vue"),
    },
    {
      path: "/water-flow/waterflow0/:id",
      name: "WaterFlow0",
      component: () => import("../views/WaterFlow/WaterFlow0.vue"),
    },
    {
      path: "/water-flow/waterflow1/:id",
      name: "WaterFlow1",
      component: () => import("../views/WaterFlow/WaterFlow1.vue"),
    },
    {
      path: "/water-flow/waterflow2/:id",
      name: "WaterFlow2",
      component: () => import("../views/WaterFlow/WaterFlow2.vue"),
    },
    {
      path: "/water-flow/waterflow3/:id",
      name: "WaterFlow3",
      component: () => import("../views/WaterFlow/WaterFlow3.vue"),
    },
    {
      path: "/water-flow/waterflow4/:id",
      name: "WaterFlow4",
      component: () => import("../views/WaterFlow/WaterFlow4.vue"),
    },
    {
      path: "/water-flow/waterflow5/:id",
      name: "WaterFlow5",
      component: () => import("../views/WaterFlow/WaterFlow5.vue"),
    },
    {
      path: "/overview-water-tank",
      name: "Overview Water Tank",
      component: () => import("../views/WaterLevelTank/Overview.vue"),
    },
    {
      path: "/report",
      name: "Report",
      component: () => import("../views/Report/Report.vue"),
    },
    {
      path: "/board/C_1A/:id",
      name: "C_1A",
      component: () => import("../views/BoardChannelDetails/C_1A.vue"),
    },
    {
      path: "/board/C_1B/:id",
      name: "C_1B",
      component: () => import("../views/BoardChannelDetails/C_1B.vue"),
    },
    {
      path: "/board/C_1C/:id",
      name: "C_1C",
      component: () => import("../views/BoardChannelDetails/C_1C.vue"),
    },
    {
      path: "/board/C_1D/:id",
      name: "C_1D",
      component: () => import("../views/BoardChannelDetails/C_1D.vue"),
    },
    {
      path: "/board/C_1E/:id",
      name: "C_1E",
      component: () => import("../views/BoardChannelDetails/C_1E.vue"),
    },
    {
      path: "/board/C_1F/:id",
      name: "C_1F",
      component: () => import("../views/BoardChannelDetails/C_1F.vue"),
    },
    {
      path: "/board/C_1G/:id",
      name: "C_1G",
      component: () => import("../views/BoardChannelDetails/C_1G.vue"),
    },
    {
      path: "/board/C_1H/:id",
      name: "C_1H",
      component: () => import("../views/BoardChannelDetails/C_1H.vue"),
    },
    {
      path: "/board/C_2A/:id",
      name: "C_2A",
      component: () => import("../views/BoardChannelDetails/C_2A.vue"),
    },
    {
      path: "/board/C_2B/:id",
      name: "C_2B",
      component: () => import("../views/BoardChannelDetails/C_2B.vue"),
    },
    {
      path: "/board/C_2C/:id",
      name: "C_2C",
      component: () => import("../views/BoardChannelDetails/C_2C.vue"),
    },
    {
      path: "/board/C_2D/:id",
      name: "C_2D",
      component: () => import("../views/BoardChannelDetails/C_2D.vue"),
    },
    {
      path: "/board/C_2E/:id",
      name: "C_2E",
      component: () => import("../views/BoardChannelDetails/C_2E.vue"),
    },
    {
      path: "/board/C_2F/:id",
      name: "C_2F",
      component: () => import("../views/BoardChannelDetails/C_2F.vue"),
    },
    {
      path: "/board/C_2G/:id",
      name: "C_2G",
      component: () => import("../views/BoardChannelDetails/C_2G.vue"),
    },
    {
      path: "/board/C_2H/:id",
      name: "C_2H",
      component: () => import("../views/BoardChannelDetails/C_2H.vue"),
    },
    {
      path: "/board/C_3A/:id",
      name: "C_3A",
      component: () => import("../views/BoardChannelDetails/C_3A.vue"),
    },
    {
      path: "/board/C_3B/:id",
      name: "C_3B",
      component: () => import("../views/BoardChannelDetails/C_3B.vue"),
    },
    {
      path: "/board/C_3C/:id",
      name: "C_3C",
      component: () => import("../views/BoardChannelDetails/C_3C.vue"),
    },
    {
      path: "/board/C_3D/:id",
      name: "C_3D",
      component: () => import("../views/BoardChannelDetails/C_3D.vue"),
    },
    {
      path: "/board/C_3E/:id",
      name: "C_3E",
      component: () => import("../views/BoardChannelDetails/C_3E.vue"),
    },
    {
      path: "/board/C_3F/:id",
      name: "C_3F",
      component: () => import("../views/BoardChannelDetails/C_3F.vue"),
    },
    {
      path: "/board/C_3G/:id",
      name: "C_3G",
      component: () => import("../views/BoardChannelDetails/C_3G.vue"),
    },
    {
      path: "/board/C_3H/:id",
      name: "C_3H",
      component: () => import("../views/BoardChannelDetails/C_3H.vue"),
    },
    {
      path: "/board/C_4A/:id",
      name: "C_4A",
      component: () => import("../views/BoardChannelDetails/C_4A.vue"),
    },
    {
      path: "/board/C_4B/:id",
      name: "C_4B",
      component: () => import("../views/BoardChannelDetails/C_4B.vue"),
    },
    {
      path: "/board/C_4C/:id",
      name: "C_4C",
      component: () => import("../views/BoardChannelDetails/C_4C.vue"),
    },
    {
      path: "/board/C_4D/:id",
      name: "C_4D",
      component: () => import("../views/BoardChannelDetails/C_4D.vue"),
    },
    {
      path: "/board/C_4E/:id",
      name: "C_4E",
      component: () => import("../views/BoardChannelDetails/C_4E.vue"),
    },
    {
      path: "/board/C_4F/:id",
      name: "C_4F",
      component: () => import("../views/BoardChannelDetails/C_4F.vue"),
    },
    {
      path: "/board/C_4G/:id",
      name: "C_4G",
      component: () => import("../views/BoardChannelDetails/C_4G.vue"),
    },
    {
      path: "/board/C_4H/:id",
      name: "C_4H",
      component: () => import("../views/BoardChannelDetails/C_4H.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated && router.app.$keycloak.hasRealmRole("admin")) {
      next();
    } else {
      if (router.app.$keycloak.authenticated) router.app.$keycloak.logoutFn();
      else {
        const loginUrl = router.app.$keycloak.createLoginUrl();
        window.location.replace(loginUrl);
      }
    }
  } else {
    next();
  }
});

export default router;
